import { createContext, useContext, type ReactNode } from "react"

const EditorPortalContext = createContext<HTMLElement | null>(null)

type EditorPortalProviderProps = {
  portalRoot: HTMLElement | null
  children: ReactNode
}

export const EditorPortalProvider = ({
  portalRoot,
  children,
}: EditorPortalProviderProps) => (
  <EditorPortalContext.Provider value={portalRoot}>
    {children}
  </EditorPortalContext.Provider>
)

export const useEditorPortalRoot = () => useContext(EditorPortalContext)
